import React, { useRef, useState, Fragment } from "react";

import { Helmet, HelmetProvider } from 'react-helmet-async'

// ゲットナビゲータ
import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";
import { Link, useNavigate } from "react-router-dom";

// スタイルインポート
import "../pages/css/contactform.scss";
import "../responsive/ContactResponsive.scss";
import "../common.scss";

// メインビジュアル
import headerSubImg from "../img/contact/contact_header.jpg";

import emailjs from "emailjs-com";
import { motion } from "framer-motion";
function ContactForm() {
  const form = useRef();
  const navigate = useNavigate();
  const [disable, setDisable] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_htsodsu",
        "template_slt57ni",
        form.current,
        "23FKQYnUnNBkZr45a"
      )
      .then((response) => {
        setDisable(true);
        navigate("/thankyou");
      })
      .catch((err) => {
        setDisable(true);
        const elementReference = document.getElementById( "btn-primary" );
        elementReference.style.background = "red";
        elementReference.style.pointerEvents = "none";
        console.log("FAILED...", err);
      });
      
  };
  return (
    <motion.div
      className="contactform"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
    <HelmetProvider>
			<Helmet prioritizeSeoTags>
			<meta charset="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<meta name="theme-color" content="#005bac" />
			<meta
				name="keywords"
				content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン,smartgenzとは？"
			/>
			<meta
				name="description"
				content="ご興味をもっていただきありがとうございます。ご相談・お問い合わせは、下記のフォームより必要事項をご記入の上、お気軽にお問い合わせください。ご希望の場合、新規お問い合せから制作の打ち合わせまで、Zoomなどでオンライン対応も可能です。"
			/>
			<meta property="og:title" content="千葉県千葉市でのホームページ制作ならSmartGenz | 無料相談" />
			<meta
				property="og:description"
				content="ご興味をもっていただきありがとうございます。ご相談・お問い合わせは、下記のフォームより必要事項をご記入の上、お気軽にお問い合わせください。ご希望の場合、新規お問い合せから制作の打ち合わせまで、Zoomなどでオンライン対応も可能です。"
			/>
			<meta property="og:type" content="article" />
			<meta property="og:url" content="https://smartgenz.com/portfolio" />
			<meta property="og:image" content="%PUBLIC_URL%/smartgenz.jpg" />
			<meta property="og:site_name" content="千葉県千葉市でのホームページ制作ならSmartGenz | 無料相談" />
			<meta property="og:locale" content="ja_JP" />
			<link rel="apple-touch-icon" href="%PUBLIC_URL%/smartgenz.jpg" />
			<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
			<link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
			<link rel="canonical" href="https://smartgenz.com/portfolio" />
			<title>千葉県千葉市でのホームページ制作ならSmartGenz | 無料相談</title>
			</Helmet>
		</HelmetProvider>
      <article className="sub-image">
        <div className="sub-main-image position-about">
          <img
            src={headerSubImg}
            alt="アイテム　｜ ヘッダーイメージ"
          ></img>
        </div>
      </article>
      <ScrollToTop />
      <section className="ctf-sec">
        <div className="sub-sec-company-ttl">
          <div className="borderA"></div>
          <h2 data-desc="無料相談">CONTACT</h2>
          <div className="borderB"></div>
        </div>
        <div className="ctf-sec-mission">
          ご興味をもっていただきありがとうございます。
          <br className="pcOnly" />
          ご相談・お問い合わせは、下記のフォームより必要事項をご記入の上、お気軽にお問い合わせください。
          <br className="pcOnly" />
          ご希望の場合、新規お問い合せから制作の打ち合わせまで、Zoomなどでオンライン対応も可能です。
        </div>
      </section>
      <section className="ctf-main-form">
        <div class="container">
          <div class="row">
            <div class="col align-self-center">
              {/* <!-- contact form --> */}
              <form ref={form} onSubmit={sendEmail}>
                {/* <!-- how do you know? --> */}
                <div class="form-group">
                  <label for="about">
                  Smartgenz（スマートジェンズ）はどこでお知りになりましたか？
                  </label>

                  <input
                    type="about"
                    name="about"
                    class="form-control"
                    id="about"
                    placeholder="（例）Google、Yahoo、WEB幹事、優良WEB"
                  />
                </div>

                {/* <!-- お問い合わせ種類 --> */}
                <div class="form-group">
                  <label for="contact-category">
                    お問合せの種別<span>（必須）</span>
                  </label>
                  <div className="select-cat">
                    <select
                      name="contact-category"
                      className="contact-category"
                      required="required"
                      id="contact-category"
                    >
                      <option value="">選択してください</option>
                      <option value="サービスについて">サービスについて</option>
                      <option value="WEBについて">WEBについて</option>
                      <option value="パートナーについて">
                        パートナーについて
                      </option>
                      <option value="その他サービスについて">
                        その他サービスについて
                      </option>
                      <option value="その他">その他</option>
                    </select>
                  </div>
                </div>

                {/* <!-- name --> */}
                <div class="form-group">
                  <label for="name">
                    お名前<span>（必須）</span>
                  </label>

                  <input
                    type="name"
                    name="name"
                    class="form-control"
                    id="name"
                    required="required"
                    placeholder="（例）田中　太郎"
                  />
                </div>

                {/* <!-- name --> */}
                <div class="form-group">
                  <label for="kana-name">
                    フリガナ<span>（必須）</span>
                  </label>
                  <input
                    type="name"
                    name="kana-name"
                    class="form-control"
                    required="required"
                    id="name"
                    placeholder="（例）タナカ　タロウ"
                  />
                </div>

                {/* <!-- name --> */}
                <div class="form-group">
                  <label for="corporate-name">会社名</label>
                  <input
                    type="name"
                    name="corporate-name"
                    class="form-control"
                    id="name"
                    placeholder="（例）株式会社〇〇〇〇"
                  />
                </div>

                {/* <!-- name --> */}
                <div class="form-group">
                  <label for="tel-num">電話番号</label>
                  <input
                    type="tel"
                    name="tel-num"
                    class="form-control"
                    id="name"
                    placeholder="（例）０４３－３５６ー０３００"
                  />
                </div>

                {/* <!-- email --> */}
                <div class="form-group">
                  <label for="email">
                    メールアドレス<span>（必須）</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    class="form-control"
                    required="required"
                    id="email"
                    placeholder="（例）contact@smartgenz.com"
                  />
                </div>

                {/* <!-- email --> */}
                <div class="form-group">
                  <label for="email-check">
                    確認のためもう一度<span>（必須）</span>
                  </label>
                  <input
                    type="email"
                    name="email-check"
                    required="required"
                    class="form-control"
                    id="email"
                    placeholder="（例）contact@smartgenz.com"
                  />
                </div>

                <div class="form-group">
                  <label for="message">お問い合わせ内容</label>
                  <textarea
                    name="message"
                    class="form-control"
                    id="message"
                    rows="5"
                    placeholder="（例）〇〇の問題点がございまして、解決できますか？"
                  ></textarea>
                </div>

                <div class="form-group pri">
                  <div className="text">
                  プライバシーポリシー<span>（必須）</span>
                  </div>
                  <label for="privacy"></label>
                  <div className="privacy">
                    <input
                      type="checkbox"
                      name="privacy"
                      required="required"
                      class="form-control"
                      id="privacy"
                    ></input>
                    <label for="privacy"><Link to="/privacy" target={"_blank"}><div className="privacy-link">プライバシーポリシー</div></Link>に同意</label>
                  </div>
                </div>

                <div className="submit-button">
                  {/* <Link to="/thankyou"> */}
                  <button type="submit" disabled={disable} class="btn btn-primary" id="btn-primary" >
                    送信
                  </button>
                  {/* </Link> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Contact />
      <Footer />
    </motion.div>
  );
}

export default ContactForm;
